// Models
import { PatchableAndDeltaSyncableODataEntity } from "../common/PatchableAndDeltaSyncableODataEntity";
/**
 * The custom field value entity implementation.
 */ export class CustomFieldValue extends PatchableAndDeltaSyncableODataEntity {
    mapEntityChangesToResource(changed, source) {
        if (changed.value === undefined) {
            return {};
        }
        return {
            value: changed.value
        };
    }
    mapDeltaChangesToEntity(delta) {
        return this.processDeltaWithTranslators(delta, {});
    }
    static fromResource(resource) {
        return new CustomFieldValue({
            id: resource.id,
            version: resource["@etag"],
            customFieldDefinitionId: resource.customFieldDefinitionId,
            value: resource.value
        });
    }
    getClone() {
        return new CustomFieldValue({
            id: this.id,
            version: this.version,
            customFieldDefinitionId: this.customFieldDefinitionId,
            value: this.value
        });
    }
    setProperty(key, value) {
        const clone = this.getClone();
        clone[key] = value;
        return clone;
    }
    forSerialization() {
        return {
            id: this.id,
            "@etag": this.version,
            customFieldDefinitionId: this.customFieldDefinitionId,
            value: this.value
        };
    }
    forCreate() {
        return {
            customFieldDefinitionId: this.customFieldDefinitionId,
            value: this.value
        };
    }
    constructor(propertyBag){
        super(propertyBag);
        this.customFieldDefinitionId = propertyBag.customFieldDefinitionId;
        this.value = propertyBag.value;
    }
}
